import ProductItem from "../../products-list/view/product-item.js";

export default class ModalProductCard extends ProductItem {
  constructor(element) {
    super(element);
  }
}
